'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getNewsFeedData(context, params = {}) {
    const defaultData = { rows: [], count: 0}
      return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/newsfeed/getnews`
        const result = await axios.get(url, {
          ...costumHeader('Get NewsFeed', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveNewsFeed(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/newsfeed/addnews`
        const result = await axios.post(url, body, costumHeader('Save NewsFeed', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editNewsFeed(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/newsfeed/editnews/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit NewsFeed', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }